/**
 * SPRINT-035B: Generic error page.
 *
 * Shown for 404s and other unrecoverable navigation errors.
 */

import { useSearchParams } from 'react-router-dom';

const REASON_MESSAGES: Record<string, string> = {
  not_found: 'La página que buscas no existe.',
  expired: 'Esta sesión de pago ha expirado.',
  unauthorized: 'No tienes acceso a esta página.',
};

export default function ErrorPage() {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason') ?? 'not_found';
  const message = REASON_MESSAGES[reason] ?? 'Ha ocurrido un error inesperado.';

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-sm border border-gray-100 p-8 text-center">
        <div className="flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full mx-auto mb-6">
          <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
          </svg>
        </div>

        <h2 className="text-xl font-bold text-gray-900 mb-2">Error</h2>
        <p className="text-gray-500 mb-6">{message}</p>

        <p className="text-xs text-gray-400">
          Por favor regresa a la tienda e intenta de nuevo.
        </p>
      </div>
    </div>
  );
}
